module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-ExtraBold.83d4db7.woff2";